import React from 'react';
import { PriceCard } from './PriceCard';
import { CtaButton } from './CtaButton';
import { OfferCountdown } from './OfferCountdown';
import { pillars, price } from '../data/salesPage';
export function FinalCtaSection() {
  return <section aria-labelledby="inversion" id="comprar" className="bg-ink" data-id="element-55" data-mp="3quuewnv0x3os">
      <div className="mx-auto max-w-5xl px-5 py-20 sm:py-28" data-id="element-56" data-mp="3vsw2nm3e9r6l">
        <h2 id="inversion" className="text-center font-display text-4xl font-black uppercase text-bone sm:text-6xl" data-id="element-57" data-mp="3vq9r7bddurj3">
          Tu inversión
        </h2>
        <div className="mt-10" data-id="element-58" data-mp="334qesqh1nm2j">
          <PriceCard eyebrow="Hoy" data-id="element-59" data-mp="331uit7orb7gq" />
        </div>

        <div className="mt-24 text-center" data-id="element-60" data-mp="382s07i1xzxh6">
          <h2 className="font-display text-3xl font-black uppercase text-bone sm:text-5xl" data-id="element-61" data-mp="380yqtuzy2z5h">¿Qué estás esperando?</h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-bone-muted" data-id="element-62" data-mp="2fedzgujgyn1x">
            Por <span className="font-semibold text-bone" data-id="element-63" data-mp="2fc9xii54ry4a">{price.current}</span> tenés acceso a una estructura completa para comenzar a trabajar en:
          </p>
          <ul className="mx-auto mt-8 grid max-w-3xl grid-cols-2 gap-px overflow-hidden rounded-2xl border border-ink-line bg-ink-line sm:grid-cols-3" data-id="element-64" data-mp="2daypdqxkp03d">
            {pillars.map(pillar => <li key={pillar} className="bg-ink-raised px-4 py-5 font-display text-base font-black uppercase tracking-wide text-bone sm:text-lg" data-id="element-65" data-mp="23lf4kfqauw5v">
                {pillar}
              </li>)}
          </ul>
          <p className="mt-6 text-lg text-bone-muted" data-id="element-66" data-mp="1uma6tbmkb6ur">Todo organizado en un solo lugar.</p>
        </div>
      </div>

      <div className="bg-lime text-ink" data-id="element-67" data-mp="1pl4cxah61djn">
        <div className="mx-auto max-w-4xl px-5 py-20 text-center sm:py-24" data-id="element-68" data-mp="1kn2u8qnnjg8p">
          <p className="font-display text-sm font-extrabold uppercase tracking-[0.25em]" data-id="element-69" data-mp="1kp5v65qcets7">Empezá hoy</p>
          <h2 className="mt-4 font-display text-5xl font-black uppercase leading-[0.95] sm:text-7xl" data-id="element-70" data-mp="1fqm8g33xddys">Cómo perder grasa en 45 días</h2>
          <div className="mx-auto mt-8 max-w-md space-y-1 text-lg font-medium sm:text-xl" data-id="element-71" data-mp="3a20y6jwxrdej">
            <p className="font-display font-bold" data-id="element-72" data-mp="18clanz5zrs5f">45 días para dejar de improvisar.</p>
            <p className="text-ink/75" data-id="element-73" data-mp="1d3jv9ay0jceh">Un sistema para aprender.</p>
            <p className="text-ink/75" data-id="element-74" data-mp="1d5wl0aa0ir23">Una estructura para aplicar.</p>
            <p className="text-ink/75" data-id="element-75" data-mp="yg8i54m6nkc9">Hábitos para mantener.</p>
          </div>
          <div className="mt-10" data-id="element-76" data-mp="13d8s3qm5l78n">
            <OfferCountdown tone="lime" data-id="element-77" data-mp="13ea2dsvchppb" />
          </div>
          <p className="mt-8 font-display text-3xl font-extrabold text-ink/60 line-through decoration-ink decoration-[4px] sm:text-4xl" data-id="element-78" data-mp="1r32z3rjsk1kz">
            <span className="sr-only" data-id="element-79" data-mp="1w25z2xkwzhm3">Precio original: </span>
            {price.reference}
          </p>
          <p className="mt-1 font-display text-7xl font-black leading-none sm:text-8xl" data-id="element-80" data-mp="1i2n290xjzsp3">{price.current}</p>
          <div className="mt-8 [&_a]:bg-ink [&_a]:text-lime [&_a:hover]:bg-ink-raised" data-id="element-81" data-mp="1m6l1dbmvp3i5">
            <CtaButton data-id="element-82" data-mp="6mg7cfo9yr0j" />
          </div>
        </div>
      </div>
    </section>;
}